import { IProjectMacra1, IProjectMacra1WithInfo } from '../../MACRA_1/store/project/projectSlice';
import { IChannelGeometryVerticalDropForm } from '../../MACRA_2/components/InputForm/ChannelGeometry/IChannelGeometry';
import { IWeirGeometrySlopedWeirForm, IWeirGeometrySteppedWeirForm, IWeirGeometryVerticalDropForm } from '../../MACRA_2/components/InputForm/WeirGeometry/IWeirGeometry';
import { IWingsGeometrySlopedWeirForm, IWingsGeometrySteppedWeirForm, IWingsGeometryVerticalDropForm } from '../../MACRA_2/components/InputForm/WingsGeometry/IWingsGeometry';
import { IProjectMacra2, IProjectMacra2WithInfo } from '../../MACRA_2/store/project/projectSlice';
import { MaterialType } from '../../enum/Material';
import { EProjectType } from '../../enum/project';
import { IFormikBOM, IFormikBOMUpdate } from '../../pages/BackofficeMaterial/IBackofficeMaterial';
import { IProjectInfoForm } from '../../pages/ProjectInfo/IProjectInfo';
import { getUser } from '../../store';
import { IMacra2TemplateRequest, IProjectMacra1Request, IProjectMacra2Request, ITemplateRequest } from '../IApiRequest';
import { ICompany, IMaterialResponse } from '../IApiResponse';
import { serializeMaterialRequestCreate, serializeMaterialRequestUpdate, serializeTemplateMacra2Request, serializeTemplateRequest } from '../utils';
import BeMaccaferriStoreProvider from './BeMaccaferriStoreProvider';

//MATERIALS------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
export const getAllBaseMaterialAsync = async (pageNumber?: number, pageSize?: number, name?: string) => BeMaccaferriStoreProvider.getAllBaseMaterialAsync(pageNumber, pageSize, name);

export const getMaterialsByTypeAsync = async (type: MaterialType) => BeMaccaferriStoreProvider.getMaterialsByTypeAsync(type);

export const getMaterialByIdAsync = async (id: number) => BeMaccaferriStoreProvider.getMaterialByIdAsync(id);

export const getMaterialWithAllLanguagesByIdAsync = async (id: number) => BeMaccaferriStoreProvider.getMaterialWithAllLanguagesByIdAsync(id);

export const getNaturalSoilMaterialsWithVelocityAsync = async () => BeMaccaferriStoreProvider.getNaturalSoilMaterialsWithVelocityAsync();

export const getIsAvailableSoilMaterials = async () => BeMaccaferriStoreProvider.getIsAvailableSoilMaterials();

export const getIsAvailableStillingBasinMaterials = async () => BeMaccaferriStoreProvider.getIsAvailableStillingBasinMaterials();

export const addMaterialAsync = async (material: IFormikBOM) => BeMaccaferriStoreProvider.addMaterialAsync(serializeMaterialRequestCreate(material));

export const updateMaterialAsync = async (data: IFormikBOMUpdate, material: IMaterialResponse) => BeMaccaferriStoreProvider.updateMaterialAsync(serializeMaterialRequestUpdate(data, material));

export const deleteMaterialByIdAsync = async (id: number) => BeMaccaferriStoreProvider.deleteMaterialByIdAsync(id);

//PROJECT------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
export const getProjectsByCompanyAsync = async (company: number, pageNumber: number, pageSize: number) => BeMaccaferriStoreProvider.getProjectsByCompanyAsync(company, pageNumber, pageSize);

export const getProjectsByAuthorAsync = async (author: string, pageNumber: number, pageSize: number) => BeMaccaferriStoreProvider.getProjectsByAuthorAsync(author, pageNumber, pageSize);

export const projectAvailableByAuthorAsync = async (id: number, author: string) => BeMaccaferriStoreProvider.projectAvailableByAuthorAsync(id, author);

export const getProjectBaseAsync = async (id: number) => BeMaccaferriStoreProvider.getProjectBaseAsync(id);

export const deleteProjectByIdAsync = async (id: number) => BeMaccaferriStoreProvider.deleteProjectByIdAsync(id);
//PROJECT - CBP
export const getProjectCBPByIdAsync = async (id: number): Promise<IProjectMacra1WithInfo> => {
    const resProject = await BeMaccaferriStoreProvider.getProjectCBPByIdAsync(id);
    const resCompany = await getCompanyByIdAsync(resProject.data.companyId);

    let project: IProjectMacra1WithInfo = {
        projectInfo: {
            city: resCompany.data.city,
            client: resProject.data.client,
            company: resCompany.data.name,
            country: resCompany.data.country,
            latitude: resProject.data.latitude,
            longitude: resProject.data.longitude,
            name: resProject.data.name,
            author: resProject.data.author,
            notes: resProject.data.notes,
            number: resProject.data.number,
            unitOfMeasure: resProject.data.unitOfMeasure,
            type: resProject.data.type,
            id: resProject.data.id,
        },
        geometry: resProject.data.sectors,
        hydraulicData: resProject.data.hydraulicData,
    };

    return project;
};

const handleCompanyAsync = async (projectInfo: IProjectInfoForm) => {
    try {
        return await getCompanyByNameAsync(projectInfo?.company!);
    } catch (error: any) {
        if (error.response.status == 404) {
            let companyPayload: ICompany = {
                name: projectInfo?.company!,
                country: projectInfo?.country!,
                city: projectInfo?.city!,
            };
            await addCompanyAsync(companyPayload);
            return await getCompanyByNameAsync(projectInfo?.company!);
        }
    }
};

export const addProjectCBPAsync = async (project: IProjectMacra1, projectInfo: IProjectInfoForm) => {
    let company = await handleCompanyAsync(projectInfo);
    const user = getUser();
    let payload: IProjectMacra1Request = {
        name: projectInfo?.name!,
        notes: projectInfo?.notes,
        client: projectInfo?.client!,
        date: new Date(),
        number: projectInfo?.number,
        latitude: projectInfo?.latitude!,
        longitude: projectInfo?.longitude!,
        author: user.data!.email!,
        unitOfMeasure: projectInfo?.unitOfMeasure!,
        type: projectInfo?.type!,
        hydraulicData: { ...project.hydraulicData!, id: undefined },
        companyId: company!.data.id!,
        sectors: project.geometry!.map(item => ({ ...item, id: undefined })),
    };

    return BeMaccaferriStoreProvider.addProjectCBPAsync(payload);
};

export const updateProjectCBPAsync = async (project: IProjectMacra1, projectInfo: IProjectInfoForm) => {
    let company = await handleCompanyAsync(projectInfo);
    const user = getUser();
    let payload: IProjectMacra1Request = {
        name: projectInfo?.name!,
        notes: projectInfo?.notes,
        client: projectInfo?.client!,
        date: new Date(),
        number: projectInfo?.number,
        latitude: projectInfo?.latitude!,
        longitude: projectInfo?.longitude!,
        author: projectInfo?.author,
        unitOfMeasure: projectInfo?.unitOfMeasure!,
        type: projectInfo?.type!,
        hydraulicData: project.hydraulicData!,
        companyId: company!.data.id!,
        sectors: project.geometry!,
        id: projectInfo.id,
    };

    return BeMaccaferriStoreProvider.updateProjectCBPAsync(payload, user.data?.email!);
};

//PROJECT - GCS
export const getProjectGCSByIdAsync = async (id: number): Promise<IProjectMacra2WithInfo> => {
    const resProject = await BeMaccaferriStoreProvider.getProjectGCSByIdAsync(id);
    const resCompany = await getCompanyByIdAsync(resProject.data.companyId);

    let project: IProjectMacra2WithInfo = {
        projectInfo: {
            city: resCompany.data.city,
            client: resProject.data.client,
            company: resCompany.data.name,
            country: resCompany.data.country,
            latitude: resProject.data.latitude,
            longitude: resProject.data.longitude,
            name: resProject.data.name,
            author: resProject.data.author,
            notes: resProject.data.notes,
            number: resProject.data.number,
            unitOfMeasure: resProject.data.unitOfMeasure,
            type: resProject.data.type,
        },
        geometry: {
            bankTopElevation: resProject.data.geometry.riverGeometryBankTopElevation,
            channelWidth: resProject.data.geometry.riverGeometryChannelWidth,
            slopeOfLeftBank: resProject.data.geometry.riverGeometrySlopeOfLeftBank,
            slopeOfRightBank: resProject.data.geometry.riverGeometrySlopeOfRightBank,
            id: resProject.data.geometry.id,
            materialId: resProject.data.geometry.materialId,
        },
        hydraulicData: resProject.data.hydraulicData,
        weirGeometry: {
            stepNumber: resProject.data.geometry.weirGeometryStepNumber,
            gabionWidth: resProject.data.geometry.weirGeometryGabbionWidth,
            stepHeight: resProject.data.geometry.weirGeometryStepHeight,
            foundationLayers: resProject.data.geometry.weirGeometryFoundationLayers,
            crestLength: resProject.data.geometry.weirGeometryTopLenght,
            stepRatio: resProject.data.geometry.weirGeometryStepRatio,
            liningThickness: resProject.data.geometry.weirGeometryLiningThickness,
            bottomLength: resProject.data.geometry.weirGeometryBottomLength,
            height: resProject.data.geometry.weirGeometryHeight,
            foundation: resProject.data.geometry.weirGeometryFoundation,
            layer: resProject.data.geometry.weirGeometryTableLayer,
        },
        wingsGeometry: {
            width: resProject.data.geometry.wingsGeometryWidth,
            height: resProject.data.geometry.wingsGeometryHeight,
            offset: resProject.data.geometry.wingsGeometryOffset,
            slopeAngle: resProject.data.geometry.wingsGeometrySlopeAngle,
        },
        stillingBasin: {
            isCounterweir: resProject.data.geometry.stillingBasinIsCounterweir,
            counterweirElevation: resProject.data.geometry.stillingBasinCounterweirElevation,
            poolLength: resProject.data.geometry.stillingBasinPoolLength,
            isStillingBasin: resProject.data.geometry.stillingBasinIsStillinBasin,
            width: resProject.data.geometry.stillingBasinWidth,
            thickness: resProject.data.geometry.stillingBasinThikness,
            stillingBasinElevation: resProject.data.geometry.stillingBasinElevation,
            material: resProject.data.geometry.material,
        },
        soilData: resProject.data.soilData,
    };

    return project;
};

export const addProjectGCSAsync = async (project: IProjectMacra2, projectInfo: IProjectInfoForm) => {
    let company = await handleCompanyAsync(projectInfo);
    const user = getUser();
    let tLayer = (<IWeirGeometryVerticalDropForm>project.weirGeometry).layer;

    let payload: IProjectMacra2Request = {
        name: projectInfo?.name!,
        notes: projectInfo?.notes,
        client: projectInfo?.client!,
        date: new Date(),
        number: projectInfo?.number,
        latitude: projectInfo?.latitude!,
        longitude: projectInfo?.longitude!,
        author: user.data!.email!,
        unitOfMeasure: projectInfo?.unitOfMeasure!,
        type: projectInfo?.type!,
        hydraulicData: { ...project.hydraulicData!, id: undefined },
        companyId: company!.data.id!,
        geometry: {
            riverGeometryBankTopElevation: project.geometry!.bankTopElevation,
            riverGeometryChannelWidth: project.geometry!.channelWidth,
            riverGeometrySlopeOfLeftBank: (<IChannelGeometryVerticalDropForm>project.geometry).slopeOfLeftBank,
            riverGeometrySlopeOfRightBank: (<IChannelGeometryVerticalDropForm>project.geometry).slopeOfRightBank,

            weirGeometryStepNumber: (<IWeirGeometrySteppedWeirForm>project.weirGeometry).stepNumber,
            weirGeometryGabbionWidth: (<IWeirGeometrySteppedWeirForm>project.weirGeometry).gabionWidth,
            weirGeometryStepHeight: (<IWeirGeometrySteppedWeirForm>project.weirGeometry).stepHeight,
            weirGeometryFoundationLayers: (<IWeirGeometrySteppedWeirForm>project.weirGeometry).foundationLayers,
            weirGeometryTopLenght: (<IWeirGeometrySlopedWeirForm>project.weirGeometry).crestLength,
            weirGeometryStepRatio: (<IWeirGeometrySteppedWeirForm | IWeirGeometrySlopedWeirForm>project.weirGeometry).stepRatio,
            weirGeometryLiningThickness: (<IWeirGeometrySlopedWeirForm>project.weirGeometry).liningThickness,
            weirGeometryBottomLength: (<IWeirGeometrySlopedWeirForm>project.weirGeometry).bottomLength,
            weirGeometryHeight: (<IWeirGeometrySlopedWeirForm>project.weirGeometry).height,
            weirGeometryFoundation: (<IWeirGeometryVerticalDropForm>project.weirGeometry).foundation,
            weirGeometryTableLayer: !!tLayer && tLayer.length > 0 ? (<IWeirGeometryVerticalDropForm>project.weirGeometry).layer.map(tl => ({ ...tl, id: undefined })) : [],

            wingsGeometryWidth: project.wingsGeometry!.width,
            wingsGeometryHeight: (<IWingsGeometryVerticalDropForm | IWingsGeometrySlopedWeirForm>project.wingsGeometry).height,
            wingsGeometryOffset: (<IWingsGeometryVerticalDropForm | IWingsGeometrySteppedWeirForm>project.wingsGeometry).offset,
            wingsGeometrySlopeAngle: (<IWingsGeometryVerticalDropForm>project.wingsGeometry).slopeAngle,

            stillingBasinIsCounterweir: project.stillingBasin!.isCounterweir,
            stillingBasinCounterweirElevation: project.stillingBasin!.counterweirElevation,
            stillingBasinPoolLength: project.stillingBasin!.poolLength,
            stillingBasinIsStillinBasin: project.stillingBasin!.isStillingBasin,
            stillingBasinWidth: project.stillingBasin!.width,
            stillingBasinThikness: project.stillingBasin!.thickness,
            stillingBasinElevation: project.stillingBasin!.stillingBasinElevation,
            material: project.stillingBasin!.material,
        },
        soilData: project.soilData,
    };

    return BeMaccaferriStoreProvider.addProjectGCSAsync(payload);
};

export const updateProjectGCSAsync = async (project: IProjectMacra2, projectInfo: IProjectInfoForm) => {
    let company = await handleCompanyAsync(projectInfo);

    let tLayer = (<IWeirGeometryVerticalDropForm>project.weirGeometry).layer;
    const user = getUser();
    let payload: IProjectMacra2Request = {
        name: projectInfo?.name!,
        notes: projectInfo?.notes,
        client: projectInfo?.client!,
        date: new Date(),
        number: projectInfo?.number,
        latitude: projectInfo?.latitude!,
        longitude: projectInfo?.longitude!,
        author: projectInfo?.author,
        unitOfMeasure: projectInfo?.unitOfMeasure!,
        type: projectInfo?.type!,
        hydraulicData: project.hydraulicData!,
        companyId: company!.data.id!,
        id: projectInfo.id,
        geometry: {
            id: project.geometry!.id,
            materialId: project.geometry!.materialId,
            riverGeometryBankTopElevation: project.geometry!.bankTopElevation,
            riverGeometryChannelWidth: project.geometry!.channelWidth,
            riverGeometrySlopeOfLeftBank: (<IChannelGeometryVerticalDropForm>project.geometry).slopeOfLeftBank,
            riverGeometrySlopeOfRightBank: (<IChannelGeometryVerticalDropForm>project.geometry).slopeOfRightBank,

            weirGeometryStepNumber: (<IWeirGeometrySteppedWeirForm>project.weirGeometry).stepNumber,
            weirGeometryGabbionWidth: (<IWeirGeometrySteppedWeirForm>project.weirGeometry).gabionWidth,
            weirGeometryStepHeight: (<IWeirGeometrySteppedWeirForm>project.weirGeometry).stepHeight,
            weirGeometryFoundationLayers: (<IWeirGeometrySteppedWeirForm>project.weirGeometry).foundationLayers,
            weirGeometryTopLenght: (<IWeirGeometrySlopedWeirForm>project.weirGeometry).crestLength,
            weirGeometryStepRatio: (<IWeirGeometrySteppedWeirForm | IWeirGeometrySlopedWeirForm>project.weirGeometry).stepRatio,
            weirGeometryLiningThickness: (<IWeirGeometrySlopedWeirForm>project.weirGeometry).liningThickness,
            weirGeometryBottomLength: (<IWeirGeometrySlopedWeirForm>project.weirGeometry).bottomLength,
            weirGeometryHeight: (<IWeirGeometrySlopedWeirForm>project.weirGeometry).height,
            weirGeometryFoundation: (<IWeirGeometryVerticalDropForm>project.weirGeometry).foundation,
            weirGeometryTableLayer: !!tLayer && tLayer.length > 0 ? (<IWeirGeometryVerticalDropForm>project.weirGeometry).layer.map(tl => ({ ...tl, id: undefined })) : [],

            wingsGeometryWidth: project.wingsGeometry!.width,
            wingsGeometryHeight: (<IWingsGeometryVerticalDropForm | IWingsGeometrySlopedWeirForm>project.wingsGeometry).height,
            wingsGeometryOffset: (<IWingsGeometryVerticalDropForm | IWingsGeometrySteppedWeirForm>project.wingsGeometry).offset,
            wingsGeometrySlopeAngle: (<IWingsGeometryVerticalDropForm>project.wingsGeometry).slopeAngle,

            stillingBasinIsCounterweir: project.stillingBasin!.isCounterweir,
            stillingBasinCounterweirElevation: project.stillingBasin!.counterweirElevation,
            stillingBasinPoolLength: project.stillingBasin!.poolLength,
            stillingBasinIsStillinBasin: project.stillingBasin!.isStillingBasin,
            stillingBasinWidth: project.stillingBasin!.width,
            stillingBasinThikness: project.stillingBasin!.thickness,
            stillingBasinElevation: project.stillingBasin!.stillingBasinElevation,

            material: project.stillingBasin!.material,
        },
        soilData: project.soilData,
    };

    return BeMaccaferriStoreProvider.updateProjectGCSAsync(payload, user.data?.email!);
};

//COMPANY------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
export const getCompanyByIdAsync = async (id: number) => BeMaccaferriStoreProvider.getCompanyByIdAsync(id);

export const getCompanyByNameAsync = async (companyName: string) => BeMaccaferriStoreProvider.getCompanyByNameAsync(companyName);

export const addCompanyAsync = async (company: ICompany) => BeMaccaferriStoreProvider.addCompanyAsync(company);

//TEMPLATES------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
export const getTemplatesByTypeAsync = async (type: EProjectType, pageNumber?: number, pageSize?: number) => BeMaccaferriStoreProvider.getTemplatesByTypeAsync(type, pageNumber, pageSize);

//template - CBP
export const getCBPWithAllLanguagesAsync = async (id: number) => BeMaccaferriStoreProvider.getCBPWithAllLanguagesAsync(id);

export const getCBPPreviewTemplatesAsync = async (pageNumber?: number, pageSize?: number, name?: string) => BeMaccaferriStoreProvider.getCBPPreviewTemplatesAsync(pageNumber, pageSize, name);

export const getTemplateCBPByIdAsync = async (id: number) => BeMaccaferriStoreProvider.getTemplateCBPByIdAsync(id);

export const addCBPTemplateAsync = async (template: ITemplateRequest) => BeMaccaferriStoreProvider.addCBPTemplateAsync(serializeTemplateRequest(template));

export const updateCBPTemplateAsync = async (template: ITemplateRequest) => BeMaccaferriStoreProvider.updateCBPTemplateAsync(serializeTemplateRequest(template));

export const deleteTemplateCBPByIdAsync = async (id: number) => BeMaccaferriStoreProvider.deleteTemplateCBPByIdAsync(id);

//template - GCS
export const getGCSWithAllLanguagesAsync = async (id: number) => BeMaccaferriStoreProvider.getGCSWithAllLanguagesAsync(id);

export const getGCSPreviewTemplatesAsync = async (pageNumber?: number, pageSize?: number, name?: string) => BeMaccaferriStoreProvider.getGCSPreviewTemplatesAsync(pageNumber, pageSize, name);

export const getTemplateGCSByIdAsync = async (id: number) => BeMaccaferriStoreProvider.getTemplateGCSByIdAsync(id);

export const addGCSTemplateAsync = async (template: IMacra2TemplateRequest) => BeMaccaferriStoreProvider.addGCSTemplateAsync(serializeTemplateMacra2Request(template, true));

export const updateGCSTemplateAsync = async (template: IMacra2TemplateRequest) => BeMaccaferriStoreProvider.updateGCSTemplateAsync(serializeTemplateMacra2Request(template));

export const deleteTemplateGCSByIdAsync = async (id: number) => BeMaccaferriStoreProvider.deleteTemplateGCSByIdAsync(id);

//blob
export const getAllDocumentsAsync = async () => BeMaccaferriStoreProvider.getAllDocumentsAsync();

export const uploadDocumentAsync = async (payload: FormData) => BeMaccaferriStoreProvider.uploadDocumentAsync(payload);

export const deleteDocumentAsync = async (name: string) => BeMaccaferriStoreProvider.deleteDocumentAsync(name);
